import { ImageLoader } from "@src/helpers/ImageLoader";
import { ImageCanvasWrapper } from "@src/saunaparts/ImageCanvasWrapper";
import ImageResolution from "@src/saunaparts/ImageResolution";
import { LayerImageRepository } from "..";
import {Layer} from "./Layer";

export class FloorLayer implements Layer
{
    imageRepository:LayerImageRepository;
    size:string;
    constructor(size:string,imageRepository:LayerImageRepository)
    {   
        this.imageRepository= imageRepository;
        this.size=size;
    }
    Render(desiredResolution: ImageResolution): Promise<HTMLCanvasElement> {
        return  new ImageLoader(this.imageRepository.getFloorLayer(this.size,desiredResolution)).Load().
        then(image=>new ImageCanvasWrapper(image,desiredResolution).getCanvas());
    }

}